import { createBrowserRouter } from 'react-router-dom'
import { lazy } from 'react'
import LazyImport from '@/components/LazyImport'
import Home from '@/pages/home'

const router = createBrowserRouter([
  // {
  //   path: '/auth',
  //   element: <LazyImport LazyChildren={lazy(() => import('../pages/auth'))} />,
  // },
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/detail',
    element: <LazyImport LazyChildren={lazy(() => import('../pages/detail'))} />,
  },
  {
    path: '*',
    element: <LazyImport LazyChildren={lazy(() => import('../pages/not-found'))} />,
  },
])

export default router
